const MessengerResource = {
  common: {
    formInvalid: 'Form is invalid',
    savingWarningTitle: 'Do you want to save the changes?',
    savingWarningContent:
      'Are you sure you want to leave now without saving the changes?',
  },
  auth: {
    loginError: 'Incorrect email, mobile phone or password.',
    recoveryPassError: 'Email/Mobile phone could not be found.',
  },
  verifyCode: {
    verifyError: 'Incorrect verification code.',
    sendCodeError: 'Fail to send verify code',
    sendCodeSuccess: 'Successfully sent.',
  },
  viewBooking: {
    notFind: 'Booking not exist',
  },
  thankYou: {
    updateNoteError: 'Unsuccessfully saved.',
    createAccountErr: 'Fail to create your account.',
  },
  account: {
    createAccountFail: 'Fail to create account',
    createPatientFail: 'Fail to create patient',
    loadListPatientKinFail: 'Fail to load list NOK',
  },
  onlineService: {
    loadListFail: 'Fail to load list online service',
  },
  preferredSite: {
    loadListError: 'Failed to load preferred site list',
  },
  bookingTimeSlot: {
    holdSlotFail: 'Slot is not available',
    holdSlotInThePastError:
      'The slot has already expired. Please choose other available ones.',
  },
};
export default MessengerResource;
